/* Druckovic Bewegung: Lenis (weiches Scrollen) + GSAP ScrollTrigger/SplitText.
   Läuft nicht im Theme-Editor und nicht bei "Bewegung reduzieren". */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gsap = window.gsap;
  if (reduce || !gsap || !window.ScrollTrigger) return;

  var ST = window.ScrollTrigger;
  gsap.registerPlugin(ST);
  if (window.SplitText) gsap.registerPlugin(window.SplitText);
  var root = document.documentElement;
  root.classList.add('has-motion');

  /* ---------- Lenis ---------- */
  var lenis = null;
  var touch = window.matchMedia('(hover: none)').matches;
  if (window.Lenis && !touch) {
    lenis = new window.Lenis({
      lerp: 0.1, wheelMultiplier: 1, smoothWheel: true, anchors: true,
      prevent: function (n) {
        return !!(n.closest && n.closest('.drawer, .search-overlay, .modal, .rail, .gallery, .thumbs, .chips-row, [data-lenis-prevent]'));
      }
    });
    lenis.on('scroll', ST.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    /* Drawer, Suche, Modal: Scrollen anhalten (theme.js setzt body.is-locked) */
    new MutationObserver(function () {
      document.body.classList.contains('is-locked') ? lenis.stop() : lenis.start();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.DruckovicLenis = lenis;
  }

  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Startzustände markieren ---------- */
  $$('.card, .step, .tile, .mascot__img, .newsletter .field-row, .moment__text, .moment .btn, .rail-head .link-btn').forEach(function (el) { el.setAttribute('data-reveal', ''); });
  $$('.mascot__img img, .gallery__item:first-child img').forEach(function (el) { el.closest('div').setAttribute('data-reveal-img', ''); });

  /* ---------- Hero ---------- */
  var heroImg = document.querySelector('.hero2__media img, .hero__media img, .hero__media video');
  if (heroImg) {
    gsap.fromTo(heroImg, { scale: 1.12 }, { scale: 1, duration: 1.8, ease: 'power3.out' });
    gsap.to(heroImg, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: heroImg.closest('section'), start: 'top top', end: 'bottom top', scrub: true } });
  }
  var heroBits = $$('.hero2__kicker, .hero2__lead, .hero2__actions, .hero2__trust, .hero__kicker, .hero__actions');
  if (heroBits.length) gsap.from(heroBits, { y: 24, opacity: 0, duration: 1, ease: 'power3.out', stagger: 0.12, delay: 0.55 });

  /* Moment: langsamer Parallax */
  $$('.moment').forEach(function (m) {
    var img = m.querySelector('.moment__media img');
    if (img) gsap.fromTo(img, { yPercent: -8, scale: 1.12 }, { yPercent: 8, scale: 1.12, ease: 'none', scrollTrigger: { trigger: m, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  /* ---------- Titel: Zeilen steigen aus der Maske ---------- */
  function splitHeadings() {
    var heads = $$('.display, .h2, .moment__title, .mascot__quote, .product__title');
    heads.forEach(function (el) {
      if (!window.SplitText) { gsap.from(el, { y: 30, opacity: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } }); return; }
      var split = window.SplitText.create(el, { type: 'lines', mask: 'lines', linesClass: 'split-line-inner' });
      var inHero = !!el.closest('.hero, .hero2');
      gsap.from(split.lines, {
        yPercent: 110, duration: inHero ? 1.25 : 1.05, ease: 'power4.out', stagger: 0.09, delay: inHero ? 0.2 : 0,
        scrollTrigger: inHero ? null : { trigger: el, start: 'top 88%', once: true }
      });
    });
  }
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(splitHeadings);

  /* ---------- Elemente einblenden ---------- */
  ST.batch('[data-reveal]', {
    start: 'top 90%', once: true,
    onEnter: function (els) { gsap.to(els, { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08, overwrite: true }); }
  });
  $$('[data-reveal-img]').forEach(function (el) {
    gsap.to(el, { clipPath: 'inset(0% 0% 0% 0% round 14px)', duration: 1.3, ease: 'power3.inOut', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
  });

  /* Laufband reagiert auf Scrollrichtung */
  var track = document.querySelector('.marquee__track');
  if (track) {
    var dir = 1;
    ST.create({ onUpdate: function (s) {
      if (s.direction !== dir) { dir = s.direction; track.style.animationDirection = dir === 1 ? 'normal' : 'reverse'; }
    } });
  }

  /* Sicherheit: falls etwas nie triggert (z. B. sehr kurze Seite), nach 3 s alles sichtbar */
  window.addEventListener('load', function () {
    ST.refresh();
    setTimeout(function () { gsap.set('[data-reveal]', { opacity: 1, y: 0 }); }, 3000);
  });
})();
